import { connect } from "react-redux"
import RegulatoryViewer from "./regulatoryViewer"
import { getRegulatoryinfo, resetRegulatoryInfo } from "../../redux/actions/regulatory/regulatoryinfo.action"
import { getRegulatoryCountry } from "../../redux/actions/regulatory/regulatoryCountry.action"
import { userConsent } from "../../redux/actions/regulatory/regulatoryUserConsent.action"
import { openAlertPopup } from "../../redux/actions/Alert/alert.action"
import { showErrorPopup } from "../../redux/actions/customErrorPopup/customerrorpopup.action"

const mapStateToProps = (state) => { 
  return {   
    myRights : state.myRights.myRights,
    regulatory: state.regulatory.regulatoryinfo,
    regulatorycountry:state.regulatory.regulatorycountry.data.data,
    isCustomErrorOpen:state.customErrorPopu.isCustomErrorOpen
  }
}

const mapDispatchToProps = (dispatch)=>{
  return {
    getRegulatoryinfo: (option=null)=>{
      return dispatch(getRegulatoryinfo(option))
    },
    getRegulatoryCountry: (option="")=>{
      return dispatch(getRegulatoryCountry(option))
    },
    resetRegulatoryInfo:()=>{
      return dispatch(resetRegulatoryInfo())
    },
    userConsent:(payload)=>{
      return dispatch(userConsent(payload))
    },
    openAlertPopup: (payload) => {
      return dispatch(openAlertPopup(payload))
    },
    showErrorPopup: (errorHeader,errormessage,isnote) => {
      return dispatch(showErrorPopup(errorHeader,errormessage,isnote))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegulatoryViewer);